import apiOrderService from './services/api.order.service';
import orderService from './services/order.service';

let storefrontOrderModule = angular.module('spabooker.storefrontOrder', [])
    .factory('apiOrderService', apiOrderService)
    .factory('order', orderService)
;
export default storefrontOrderModule.name;


// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/order/index.js